import { render, staticRenderFns } from "./NotificationPhoneLog.vue?vue&type=template&id=672d623e&"
import script from "./NotificationPhoneLog.vue?vue&type=script&lang=ts&"
export * from "./NotificationPhoneLog.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationPhoneLog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports